// eslintのjsDocの項目をスルーさせている
/**
 *  [2021] Zettant Incorporated
 *  All Rights Reserved.
 *
 * NOTICE:  All information contained herein is, and remains
 * the property of Zettant Incorporated and its suppliers,
 * if any.  The intellectual and technical concepts contained
 * herein are proprietary to Zettant Incorporated and its
 * suppliers and may be covered by Japan. and Foreign Patents,
 * patents in process, and are protected by trade secret or
 * copyright law. Dissemination of this information or
 * rebusinession of this material is strictly forbidden unless
 * prior written permission is obtained from Zettant Incorporated.
 */

const SIZE = 10;

let recentErrorCode = 0;
let recentErrorMessage = '';

const messages: { [key: string]: string | number }[] = [];

/**
 * `
 */
const getErrorCode = () => recentErrorCode;

/**
 * `
 */
const getError = () => recentErrorMessage;

/**
 * `
 */
const setNoError = () => {
  recentErrorCode = 0;
  recentErrorMessage = '';
};

/**
 * `
 * @param num `
 */
const get = (num?: number): { [key: string]: string | number } => {
  if (!num) num = 0;
  if (messages.length === 0) {
    return {};
  }
  return messages[messages.length - num];
};

/**
 * `
 * @param msg メッセージ
 * @param code `
 */
const set = (msg = '', code = 0) => {
  recentErrorCode = code;
  recentErrorMessage = msg;
  if (messages.length === SIZE) {
    messages.shift();
  }
  const m: { [key: string]: string | number } = { msg };
  messages.push(m);
};

export default { getErrorCode, getError, setNoError, get, set };
export { getErrorCode, getError, setNoError, get, set };
